export const featuredProducts = [
  {
    id: 1,
    name: 'ساعة ذكية عصرية بتصميم أنيق',
    price: 599,
    originalPrice: 799,
    discount: 25,
    rating: 5,
    reviews: 128,
    image: 'https://public.readdy.ai/ai/img_res/10768fcff14642c7a0ef792720a65f89.jpg',
    category: 'electronics'
  },
  {
    id: 2,
    name: 'حقيبة يد جلدية فاخرة للنساء',
    price: 449,
    originalPrice: null,
    discount: null,
    rating: 5,
    reviews: 95,
    image: 'https://readdy.ai/api/search-image?query=luxury%20leather%20handbag%20for%20women%20on%20clean%20white%20minimalist%20background%2C%20elegant%20designer%20bag%20displayed%20beautifully%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-002&orientation=squarish',
    category: 'fashion'
  },
  {
    id: 3,
    name: 'سماعات لاسلكية بجودة صوت عالية',
    price: 299,
    originalPrice: 399,
    discount: 25,
    rating: 4,
    reviews: 203,
    image: 'https://readdy.ai/api/search-image?query=premium%20wireless%20headphones%20with%20high%20quality%20sound%20on%20clean%20white%20minimalist%20background%2C%20modern%20audio%20device%20displayed%20professionally%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-003&orientation=squarish',
    category: 'electronics'
  },
  {
    id: 4,
    name: 'مجموعة عناية بالبشرة الطبيعية',
    price: 349,
    originalPrice: null,
    discount: null,
    rating: 5,
    reviews: 167,
    image: 'https://readdy.ai/api/search-image?query=natural%20skincare%20product%20set%20on%20clean%20white%20minimalist%20background%2C%20organic%20beauty%20products%20arranged%20elegantly%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-004&orientation=squarish',
    category: 'beauty'
  },
  {
    id: 5,
    name: 'حذاء رياضي مريح للجري',
    price: 399,
    originalPrice: 499,
    discount: 20,
    rating: 5,
    reviews: 142,
    image: 'https://readdy.ai/api/search-image?query=comfortable%20running%20sports%20shoes%20on%20clean%20white%20minimalist%20background%2C%20athletic%20footwear%20displayed%20professionally%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-005&orientation=squarish',
    category: 'sports'
  },
  {
    id: 6,
    name: 'مصباح طاولة LED عصري',
    price: 179,
    originalPrice: null,
    discount: null,
    rating: 4,
    reviews: 89,
    image: 'https://readdy.ai/api/search-image?query=modern%20LED%20desk%20lamp%20on%20clean%20white%20minimalist%20background%2C%20contemporary%20table%20light%20displayed%20elegantly%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-006&orientation=squarish',
    category: 'home-decor'
  },
  {
    id: 7,
    name: 'كاميرا رقمية احترافية',
    price: 2499,
    originalPrice: 2999,
    discount: 17,
    rating: 5,
    reviews: 76,
    image: 'https://readdy.ai/api/search-image?query=professional%20digital%20camera%20on%20clean%20white%20minimalist%20background%2C%20high%20end%20photography%20equipment%20displayed%20professionally%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-007&orientation=squarish',
    category: 'electronics'
  },
  {
    id: 8,
    name: 'نظارات شمسية بتصميم عصري',
    price: 249,
    originalPrice: null,
    discount: null,
    rating: 4,
    reviews: 134,
    image: 'https://readdy.ai/api/search-image?query=stylish%20modern%20sunglasses%20on%20clean%20white%20minimalist%20background%2C%20fashionable%20eyewear%20displayed%20elegantly%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-008&orientation=squarish',
    category: 'accessories'
  }
];

export const allProducts = [
  ...featuredProducts,
  {
    id: 9,
    name: 'لابتوب خفيف الوزن للأعمال',
    price: 3499,
    originalPrice: 3999,
    discount: 13,
    rating: 5,
    reviews: 156,
    image: 'https://readdy.ai/api/search-image?query=lightweight%20business%20laptop%20on%20clean%20white%20minimalist%20background%2C%20sleek%20portable%20computer%20displayed%20professionally%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-009&orientation=squarish',
    category: 'electronics'
  },
  {
    id: 10,
    name: 'فستان سهرة أنيق',
    price: 699,
    originalPrice: null,
    discount: null,
    rating: 5,
    reviews: 98,
    image: 'https://readdy.ai/api/search-image?query=elegant%20evening%20dress%20on%20clean%20white%20minimalist%20background%2C%20sophisticated%20formal%20gown%20displayed%20beautifully%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-010&orientation=squarish',
    category: 'fashion'
  },
  {
    id: 11,
    name: 'طقم أواني طبخ احترافي',
    price: 899,
    originalPrice: 1199,
    discount: 25,
    rating: 5,
    reviews: 187,
    image: 'https://readdy.ai/api/search-image?query=professional%20cookware%20set%20on%20clean%20white%20minimalist%20background%2C%20premium%20kitchen%20pots%20and%20pans%20arranged%20elegantly%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-011&orientation=squarish',
    category: 'home-decor'
  },
  {
    id: 12,
    name: 'دراجة هوائية جبلية',
    price: 1899,
    originalPrice: null,
    discount: null,
    rating: 4,
    reviews: 112,
    image: 'https://readdy.ai/api/search-image?query=mountain%20bicycle%20on%20clean%20white%20minimalist%20background%2C%20outdoor%20sports%20bike%20displayed%20professionally%2C%20high%20quality%20product%20photography%20with%20soft%20studio%20lighting%20and%20simple%20backdrop&width=400&height=400&seq=prod-012&orientation=squarish',
    category: 'sports'
  }
];
